import { ADDITIONAL_CMS_OPTIONS_FROM_DOM, ADDITIONAL_CONTENT_CONTAINER } from 'Constant';
import * as constants from '../constant';
import { getQueryParam } from '@vfde-sails/utils';
import { ENV_PRODUCTION } from '@vfde-sails/constants';

/**
 * Appends static HTML content to DOM
 * @param staticHTMLContent - containing the static HTML content ti be injected in the DOM
 */
export const appendAdditionalContentToDOM = (staticHTMLContent: string = ''): void => {
    const parentContainer = document.getElementById(ADDITIONAL_CONTENT_CONTAINER);
    if (parentContainer) {
        parentContainer.innerHTML = staticHTMLContent;
        hideAdditionalContainers(parentContainer);
    }
};

const hideAdditionalContainers = (parentContainer: HTMLElement): void => {
    const additionalContContainers = parentContainer.children as HTMLCollectionOf<HTMLDivElement>;
    for (let i = 0; i < additionalContContainers.length; i++) {
        additionalContContainers[i].classList.add('brix-is-hidden');
    }
};

/**
 * Mocked additional content shall be used.
 */
export const isAdditionalContentToBeMocked = () => {
    if (process.env.NODE_ENV === ENV_PRODUCTION) {
        return false;
    }

    return getQueryParam(constants.ADDITIONAL_CONTENT_USEMOCK_URL_PARAM) === 'true';
};
